import { useEffect } from 'react';
/**
 *
 * @param ref
 * @param handler - Must be stable. Use useCallback or similar solution.
 * @param disabled
 */ export const useOnClickOutside = (ref, handler, disabled = false)=>{
    useEffect(()=>{
        if (disabled) return undefined;
        const listener = (evt)=>{
            const el = ref.current;
            if (!el || el.contains(evt.target)) {
                return;
            }
            handler(evt);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return ()=>{
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [
        ref,
        handler,
        disabled
    ]);
};
